import L from "leaflet"
import { MapConfig } from "./map_config.js";
import { LocationHandler } from "./location_handler.js";

export class MapFactory {
  static createMainMap(container, center, options = {}) {
    const defaultOptions = {
      scrollWheelZoom: options.wheelZoom !== 'false'
    };

    const map = L.map(container, defaultOptions).setView(center, 14);

    // Build switchable base layers (Teren/Karta/Satelit) and show the default one.
    // The switcher UI lives in the custom Layers card (see map_controller#switchBaseLayer),
    // so we expose the layers on the map instance instead of using Leaflet's own control.
    const baseLayers = MapConfig.getBaseLayers(options.layerType);
    const defaultLabel = options.activeBaseLayer || (options.layerType == 'thunderforest' ? 'Teren' : 'Karta');
    const defaultLayer = baseLayers[defaultLabel] || Object.values(baseLayers)[0];
    defaultLayer.addTo(map);
    map.baseLayers = baseLayers;
    map.activeBaseLayer = defaultLayer;

    // Add scale control
    L.control.scale().addTo(map);

    // Setup location control
    const locationHandler = new LocationHandler(map);
    locationHandler.setupLocationControl();

    return map;
  }

  static createPreviewMap(container, center) {
    const map = L.map(container, { scrollWheelZoom: false }).setView(center, 14);
    
    // Add OSM tile layer for preview
    const osmConfig = MapConfig.getOSMTileLayerOptions();
    L.tileLayer(osmConfig.url, osmConfig.options).addTo(map);

    // Add scale control
    L.control.scale().addTo(map);

    return map;
  }
}
